import { CurrencyPipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { GastosService } from '../../../services/gastos/gastos.service';
import { SeguimientoService } from '../../../services/seguimiento/seguimiento.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-gastos',
  templateUrl: './gastos.component.html',
  styleUrls: ['./gastos.component.scss'],
  standalone: false,
  providers: [MessageService, CurrencyPipe]
})

export class GastosComponent implements OnInit {
  loadMenu: boolean = true;
  load: boolean = false;
  dateQuery: Date = new Date();
  typeExpenses: Array<any> = [];
  formRegistro = new FormGroup({
    tipoGasto: new FormControl(null, Validators.required),
    descripcion: new FormControl('', [Validators.required, Validators.maxLength(100), Validators.minLength(5)]),
    valor: new FormControl(0, [Validators.required, Validators.minLength(3)])
  })
  infoUser: any = {}
  infoEmpresa: Array<any> = [];
  infoPagos: Array<any> = [];
  infoGastos: Array<any> = [];
  token: any = {};
  btnShow: boolean = true;
  msgText: String = "";
  valorMaxPermitido: number = 0;
  totalGastos: number = 0;
  totalGastosAnt: number = 0;
  @ViewChild('btnRegister') btnRegister: any;

  constructor(private message: MessageService,
    private gasto: GastosService,
    private seguimiento: SeguimientoService,
    private currency: CurrencyPipe
  ) {

  }

  ngOnInit(): void {
    let fecha: Date = new Date();
    this.load = true;
    this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
    this.infoUser = JSON.parse(localStorage.getItem('infoUser') ?? "[]");
    this.infoEmpresa = JSON.parse(localStorage.getItem('empresa') ?? "[]");

    this.getTipoGastos();


    const dateConvert = fecha.getFullYear() + '-' + (fecha.getMonth() + 1) + "-" + fecha.getDate();
    this.seguimiento.getVentasDiscriminacionPago(this.token.token, dateConvert, dateConvert, this.infoUser.empleadoProveedors[0].idEmpleadoProveedor).subscribe({
      next: (response) => {
        this.infoPagos = response as Array<any>;
        this.load = false;
        if (this.infoPagos.length == 0) {
          this.btnShow = false;
          this.message.add({ severity: 'warn', summary: 'Información', detail: 'En el momento no se ha recibido dinero, intenta mas tarde' });
          this.msgText = "<div class='p-message p-message-info'>En el momento no se ha recibido dinero, intenta mas tarde</div>"
        }
        else {

          // importar gastos del dìa actual
          this.gasto.getGastos(this.token.token, dateConvert, dateConvert).subscribe((resp) => {
            this.infoGastos = resp as Array<any>;
            this.infoGastos.forEach((row: any) => {
              this.totalGastos += row.valor;
              this.totalGastosAnt += row.valor;
            });
            // obtención de ¡l valor maximo a registrar

            this.valorMaxPermitido = this.infoPagos.filter(row => {
              return row.referencia == "Efectivo"
            })[0].valor;

            this.valorMaxPermitido -= this.totalGastos;
            if (this.valorMaxPermitido == 0)
              this.btnShow = false;
            this.msgText = '<div class="p-1 p-message p-message-success">Valor disponible ' + this.currency.transform(this.valorMaxPermitido) + '</div>';
          })
        }

      }, error: (error: Response) => {
        window.location.href = "/";
      }
    });
  }

  getTipoGastos = () => {
    this.gasto.getTipoGastos(this.token.token).subscribe({
      next: (response) => { this.typeExpenses = response as Array<any>; console.log(response) },
      error: (error: HttpErrorResponse) => { console.error(error) }
    })
  }

  getInfoGastos = () => {
    this.totalGastosAnt = 0;
    this.load = true;
    const dateConvert = this.dateQuery.getFullYear() + '-' + (this.dateQuery.getMonth() + 1) + "-" + this.dateQuery.getDate();
    this.gasto.getGastos(this.token.token, dateConvert, dateConvert).subscribe((resp) => {
      this.infoGastos = resp as Array<any>;
      this.load = false;
      if (this.infoGastos.length == 0)
        this.message.add({ severity: 'warn', summary: 'Información', detail: 'No se han generado gastos' });
      this.infoGastos.forEach((row: any) => {
        this.totalGastosAnt += row.valor;
      });
    });
  }

  setGasto = () => {
    this.btnRegister.nativeElement.disabled = true;
    if (this.formRegistro.valid) {
      if ((this.formRegistro.controls["valor"].value ?? 0) <= this.valorMaxPermitido) {
        this.load = true;
        const data: any = {
          idTipoGasto: (this.formRegistro.controls.tipoGasto.value as any).idTipoGasto,
          idEmpleadoProveedor: this.infoUser.empleadoProveedors[0].idEmpleadoProveedor,
          idTienda: this.infoEmpresa[0].tiendaEmpleados[0].idTienda,
          observacion: this.formRegistro.controls.descripcion.value,
          valor: this.formRegistro.controls.valor.value
        }
        this.gasto.setGastos(this.token.token, data).subscribe((response) => {
          this.message.add({ severity: 'success', summary: 'Información', detail: response.toString() });
          this.valorMaxPermitido -= data.valor;

          this.msgText = '<div class="p-message p-message-info p-2">Valor disponible ' + this.currency.transform(this.valorMaxPermitido) + '</div>';
          this.load = false;
          this.formRegistro.controls.valor.setValue(0);
          this.formRegistro.controls.descripcion.setValue("");
          this.btnRegister.nativeElement.disabled = false;
          if (this.valorMaxPermitido == 0)
            this.btnShow = false;
        })
      }
      else {
        this.message.add({ severity: 'warn', summary: 'Información', detail: 'No hay suficiente dinero' });
        this.btnRegister.nativeElement.disabled = false;
      }
    }
    else {
      this.message.add({ severity: 'warn', summary: 'Información', detail: 'Favor relacione los campos requeridos' });
      this.btnRegister.nativeElement.disabled = false;
    }
  }

  printDiv(elem: string, title: string, index?: number) {
    console.log(index, elem);
    if (!!index)
      elem = elem + index;
    const dateConvert = this.dateQuery.getFullYear() + '-' + (this.dateQuery.getMonth() + 1) + "-" + this.dateQuery.getDate();

    let mywindow: any = window.open('', 'PRINT', 'height=400,width=800');

    mywindow.document.write('<html><head><title>' + document.title + '</title>');
    mywindow.document.write('<style>.grid {display: flex; margin-right: -.5rem; margin-left: -.5rem;margin-top: -.5rem;} .col-6{ flex: 0 0 auto; padding: .5rem; width:50%} .hidden{display:none;} </style>');
    mywindow.document.write('</head><body style="font-family: \'Segoe UI\' !important; font-size: 22px !important;" >');
    mywindow.document.write('<h5>' + title.toUpperCase() + ' CORRESPONDIENTE AL DÍA ' + dateConvert + '</h5><div style="text-align:center; width:302px">');
    mywindow.document.write(document.getElementById(elem)!.innerHTML);
    mywindow.document.write('</div></body></html>');

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();
    mywindow.close();

    return true;

  }
}
